var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-info-widget-component" },
    [
      _vm.disableJoin ? _c("popup-join-dialog") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoggedIn
        ? _c(
            "div",
            { staticClass: "login-info" },
            [
              _vm.brandKey === "qcasino"
                ? [
                    _c(
                      "v-btn",
                      {
                        staticClass: "login_btn",
                        attrs: { id: "login_btn" },
                        on: {
                          click: function($event) {
                            return _vm.openDialogLogin()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { id: "qa-login_btn" } }, [
                          _vm._v(_vm._s(_vm.$t("MyAccount.LogIn")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "join-now",
                        on: {
                          click: function($event) {
                            return _vm.joinAction()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { id: "qa-join-now" } }, [
                          _vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))
                        ])
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.brandLayout !== "generic" && _vm.brandKey !== "qcasino"
                ? [
                    !_vm.mobileBigAndBelow ||
                    _vm.brandKey === "sb" || _vm.brandKey === "mav"
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "login_btn",
                            attrs: { id: "login_btn" },
                            on: {
                              click: function($event) {
                                return _vm.openDialogLogin()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { id: "qa-login_btn" } }, [
                              _vm._v(_vm._s(_vm.$t("MyAccount.LogIn")))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.mobileBigAndBelow
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "join-now",
                            on: {
                              click: function($event) {
                                return _vm.joinAction()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { id: "qa-join-now" } }, [
                              _vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mobileBigAndBelow &&
                    _vm.brandKey !== "sb" && _vm.brandKey !== "mav"
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "account_btn",
                            attrs: { ripple: false },
                            on: {
                              click: function($event) {
                                return _vm.openDialogLogin()
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("account_circle")])],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mobileBigAndBelow
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "join-now",
                            on: {
                              click: function($event) {
                                return _vm.joinAction()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { id: "qa-join-now" } }, [
                              _vm._v(_vm._s(_vm.$t("MyAccount.JoinNow")))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.brandLayout === "generic" &&
              (!_vm.showPageTitleInHeader ||
                !_vm.mobileBigAndBelow ||
                _vm.isRootSportsNavigation ||
                ["pm", "racing"].includes(_vm.currentNavGroupKey))
                ? [
                    _vm.brandTemplate !== "generic_2"
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "join-now",
                            on: {
                              click: function($event) {
                                return _vm.joinAction()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { id: "qa-join-now" } }, [
                              _vm._v(_vm._s(_vm.$t("MyAccount.Header.JoinNow")))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "login_btn",
                        attrs: { id: "login_btn" },
                        on: {
                          click: function($event) {
                            return _vm.openDialogLogin()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { id: "qa-login_btn" } }, [
                          _vm._v(_vm._s(_vm.$t("MyAccount.Header.LogIn")))
                        ])
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogLogin
                ? _c(
                    "v-dialog",
                    {
                      attrs: {
                        "content-class": "dialog-login expand desktopLogin",
                        fullscreen:
                          _vm.brandTemplate === "generic_2" &&
                          !_vm.isLoggedIn &&
                          _vm.mobileBigAndBelow,
                        persistent: ""
                      },
                      model: {
                        value: _vm.dialogLogin,
                        callback: function($$v) {
                          _vm.dialogLogin = $$v
                        },
                        expression: "dialogLogin"
                      }
                    },
                    [_c("login-component")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogMyAccount && _vm.mobileBigAndBelow
                ? _c(
                    "v-dialog",
                    {
                      attrs: {
                        "content-class": _vm.dialogMyaccount,
                        persistent: "",
                        fullscreen:
                          (_vm.brandTemplate === "generic_2" &&
                            !_vm.isLoggedIn) ||
                          _vm.isLoggedIn,
                        "hide-overlay": _vm.isLoggedIn,
                        transition: "dialog-bottom-transition"
                      },
                      model: {
                        value: _vm.dialogMyAccount,
                        callback: function($$v) {
                          _vm.dialogMyAccount = $$v
                        },
                        expression: "dialogMyAccount"
                      }
                    },
                    [_c("login-component")],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c(
            "div",
            { staticClass: "account-info" },
            [
              _vm.brandKey === "sb" ||
              _vm.brandKey === "mav" ||
              _vm.brandKey === "qcasino"
                ? [
                    _c(
                      "div",
                      { staticClass: "acc_buttons" },
                      [
                        (_vm.xtremepushWebInitialized ||
                          _vm.xtremePushEnabledMobile) &&
                        _vm.xtremepushInboxEnabled
                          ? _c("xtremepush-inbox")
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noOfMsgs > 0 ? _c("message-center") : _vm._e(),
                        _vm._v(" "),
                        !_vm.mobileBigAndBelow
                          ? _c(
                              "span",
                              {
                                staticClass: "shw-balance",
                                attrs: { id: "qa-shw-balance" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.buttonAction()
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _c("span", { staticClass: "amount" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("currency")(_vm.balanceSum))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.brandKey === "sb"
                                    ? _c(
                                        "span",
                                        { staticClass: "addfunds" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("MyAccount.AddFunds"))
                                          ),
                                          _c("v-icon", [_vm._v("add")])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mobileBigAndBelow
                          ? _c(
                              "span",
                              {
                                staticClass: "shw-balance",
                                attrs: { id: "qa-shw-balance" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.buttonAction()
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "amount" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("currency")(_vm.balanceSum))
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.brandKey === "sb"
                                  ? _c(
                                      "span",
                                      { staticClass: "addfunds" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("MyAccount.AddFunds"))
                                        ),
                                        _c("v-icon", [_vm._v("add")])
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tabletAndAbove
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "my_profile",
                                on: {
                                  click: function($event) {
                                    return _vm.goToProfile()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("account_circle")])],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.brandLayout === "generic"
                ? [
                    _vm.brandTemplate !== "generic_2"
                      ? _c(
                          "div",
                          { staticClass: "acc_buttons" },
                          [
                            (_vm.xtremepushWebInitialized ||
                              _vm.xtremePushEnabledMobile) &&
                            _vm.xtremepushInboxEnabled
                              ? _c("xtremepush-inbox")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.noOfMsgs > 0 ? _c("message-center") : _vm._e(),
                            _vm._v(" "),
                            !_vm.mobileBigAndBelow
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "shw-balance",
                                    attrs: { id: "qa-shw-balance" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.buttonAction()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _c("span", { staticClass: "amount" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(_vm.balanceSum)
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "addfunds" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("MyAccount.AddFunds"))
                                          ),
                                          _c("v-icon", [_vm._v("add")])
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mobileBigAndBelow
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "shw-balance",
                                    attrs: { id: "qa-shw-balance" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.buttonAction()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "amount" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.balanceSum)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "addfunds" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("MyAccount.AddFunds"))
                                        ),
                                        _c("v-icon", [_vm._v("add")])
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.tabletAndAbove
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "my_profile",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToProfile()
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("account_circle")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandTemplate === "generic_2"
                      ? _c(
                          "div",
                          { staticClass: "acc_buttons" },
                          [
                            !_vm.mobileBigAndBelow
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "shw-balance",
                                    attrs: { id: "qa-shw-balance" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.buttonAction()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "amount" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.balanceSum)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "addfunds" },
                                      [_c("v-icon", [_vm._v("add")])],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mobileBigAndBelow
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "shw-balance",
                                    attrs: { id: "qa-shw-balance" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.buttonAction()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "amount" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.balanceSum)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "addfunds" },
                                      [_c("v-icon", [_vm._v("add")])],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.tabletAndAbove
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "my_profile",
                                    class: { withAlerts: _vm.noOfMsgs > 0 },
                                    on: {
                                      click: function($event) {
                                        return _vm.goToProfile()
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("account_circle")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.mobileBigAndBelow && _vm.isLoggedIn
                ? _c(
                    "v-dialog",
                    {
                      attrs: {
                        "content-class": "dialogMyAccountDesktop",
                        width: "450",
                        transition: "dialog-right-transition"
                      },
                      model: {
                        value: _vm.dialogMyAccountDesktop,
                        callback: function($$v) {
                          _vm.dialogMyAccountDesktop = $$v
                        },
                        expression: "dialogMyAccountDesktop"
                      }
                    },
                    [
                      _c("div", { staticClass: "account_desktop" }, [
                        _vm.brandTemplate !== "generic_2"
                          ? _c("div", { staticClass: "account_details" }, [
                              _c("div", { staticClass: "user_details" }, [
                                _c(
                                  "div",
                                  { staticClass: "user_image" },
                                  [_c("v-icon", [_vm._v("account_circle")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "user_title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customerContext.Name &&
                                        _vm.customerContext.Name[0]
                                    ) +
                                      " " +
                                      _vm._s(_vm.customerContext.Name[1]) +
                                      "\n              "
                                  ),
                                  _vm.brandKey === "mav"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "accountnumber accountnumber--mav"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MyAccount.AccountNumber"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.accountNumber || "--")
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "account_balance" }, [
                                _c("div", { staticClass: "balace_bonus" }, [
                                  _c("div", { staticClass: "balance" }, [
                                    _c(
                                      "span",
                                      {
                                        key: "current_balance",
                                        staticClass: "text"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("MyAccount.TotalCash"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.balanceSum)
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.promoBalanceSum
                                    ? _c("div", { staticClass: "balance" }, [
                                        _c(
                                          "span",
                                          {
                                            key: "current_balance",
                                            staticClass: "text"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("MyAccount.PromoBalance")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("currency")(
                                                _vm.promoBalanceSum
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "session_details",
                                    class: "session_details--" + _vm.brandKey
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.brandKey !== "mav" &&
                                              _vm.brandKey !== "qcasino",
                                            expression:
                                              "brandKey !== 'mav' && brandKey !== 'qcasino'"
                                          }
                                        ],
                                        staticClass: "accountnumber"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "lastlogdur" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MyAccount.AccountNumber"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.accountNumber || "--")
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.brandKey !== "mav"
                                      ? _c(
                                          "div",
                                          { staticClass: "lastlogin" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "lastlogdur" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MyAccount.LastLogin"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.lastLogin || "--")
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.brandKey !== "mav" && _vm.state !== "NJ"
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              key: "session_info_duration",
                                              staticClass: "lastlogdur"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "MyAccount.SessionTime"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.sessionTime))
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.brandKey !== "mav" && _vm.state === "NJ"
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              key: "session_info_duration",
                                              staticClass: "lastlogdur"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "MyAccount.SessionTime." +
                                                      _vm.state
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.sessionTime))
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.brandKey === "mav"
                                      ? _c(
                                          "div",
                                          { staticClass: "lastlogin" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "lastlogdur" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MyAccount.LastLogin"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _c("br"),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.lastLogin || "--")
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.brandKey === "mav"
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              key: "session_info_duration",
                                              staticClass: "lastlogdur"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "MyAccount.SessionTime"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _c("br"),
                                            _vm._v(
                                              " " + _vm._s(_vm.sessionTime)
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "buttons" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "transactions deposit",
                                      class: [
                                        {
                                          geolocation_check_in_progress:
                                            _vm.tempPromotionTypeFromSessionStorage &&
                                            _vm
                                              .tempPromotionTypeFromSessionStorage
                                              .name === "deposit" &&
                                            _vm.geolocationProgress !==
                                              "completed"
                                        }
                                      ],
                                      attrs: {
                                        id: "my_profile_deposit_btn",
                                        color: "success",
                                        "x-large": ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.depositAction()
                                        }
                                      }
                                    },
                                    [
                                      !_vm.tempPromotionTypeFromSessionStorage ||
                                      (_vm.tempPromotionTypeFromSessionStorage &&
                                        _vm.tempPromotionTypeFromSessionStorage
                                          .name !== "deposit") ||
                                      !_vm.geolocationProgress ||
                                        _vm.geolocationProgress === "completed"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("MyAccount.Deposit")
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.tempPromotionTypeFromSessionStorage &&
                                      _vm.tempPromotionTypeFromSessionStorage
                                        .name === "deposit" &&
                                      _vm.geolocationProgress !== "completed"
                                        ? _c("dots-loader")
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "transactions withdraw",
                                      attrs: {
                                        id: "my_profile_withdraw_btn",
                                        "x-large": ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.go2WalletPage("withdrawal")
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("MyAccount.Withdraw"))
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.cashDepositAtKiosk ||
                              _vm.withdrawAtSportsbookButton
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "buttons second_row",
                                      class: {
                                        two_buttons:
                                          _vm.cashDepositAtKiosk &&
                                          _vm.withdrawAtSportsbookButton
                                      }
                                    },
                                    [
                                      _vm.cashDepositAtKiosk
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "transactions deposit",
                                              attrs: {
                                                id:
                                                  "my_profile_deposit_at_kiosk_btn",
                                                "x-large": ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.go2DepositAtKioskPage()
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MyAccount.DepositAtKiosk"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.withdrawAtSportsbookButton
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "transactions withdraw ri-wd-cashinshop",
                                              attrs: {
                                                id: "my_profile_withdraw_btn",
                                                "x-large": ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.go2CashInShopPage()
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Payments.CashInShop"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brandTemplate === "generic_2"
                          ? _c("div", { staticClass: "account_details" }, [
                              _c("div", { staticClass: "user_details" }, [
                                _c(
                                  "div",
                                  { staticClass: "user_details_name" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "user_notifications" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "user_image",
                                            class: {
                                              withAlerts: _vm.noOfMsgs > 0
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.openMsgCenterDialog()
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("account_circle")
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        (_vm.xtremepushWebInitialized ||
                                          _vm.xtremePushEnabledMobile) &&
                                        _vm.xtremepushInboxEnabled
                                          ? _c("xtremepush-inbox")
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "user_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customerContext.Name &&
                                            _vm.customerContext.Name[0]
                                        ) +
                                          " " +
                                          _vm._s(_vm.customerContext.Name[1]) +
                                          "\n              "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "sessionDetails" }, [
                                  _c("p", { staticClass: "accountnumber" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("MyAccount.AccountNumber")
                                        )
                                      )
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(_vm.accountNumber || "--")
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.state !== "NJ"
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "sessionDuration sessiondur"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("MyAccount.SessionTime")
                                              )
                                            )
                                          ]),
                                          _vm._v(" " + _vm._s(_vm.sessionTime))
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.state === "NJ"
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "sessionDuration sessiondur"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MyAccount.SessionTime." +
                                                    _vm.state
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" " + _vm._s(_vm.sessionTime))
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "lastlogin lastlogdur" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("MyAccount.LastLogin"))
                                        )
                                      ]),
                                      _vm._v(" " + _vm._s(_vm.lastLogin))
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.state === "NJ"
                                    ? _c("p", { staticClass: "current-time" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("MyAccount.CurrentTime")
                                            )
                                          )
                                        ]),
                                        _vm._v(" " + _vm._s(_vm.currentTime))
                                      ])
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "balance_actions" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "account_balance",
                                    class: {
                                      withPromoBalance: _vm.promoBalanceSum
                                    }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "balance",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.refreshAccountsDetails()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "balance_holder" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "text" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MyAccount.TotalCash"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                !_vm.balanceLoader
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "value",
                                                        attrs: {
                                                          id:
                                                            "sportbook-balance"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              _vm.balanceSum ||
                                                                0
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.balanceLoader
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "loading"
                                                      },
                                                      [_c("dots-loader")],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.promoBalanceSum
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "balance_holder"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MyAccount.PromoBalance"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.balanceLoader
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass: "value"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency"
                                                                )(
                                                                  _vm.promoBalanceSum ||
                                                                    0
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.balanceLoader
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "loading"
                                                          },
                                                          [_c("dots-loader")],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "buttons_holder" }, [
                                  _c(
                                    "div",
                                    { staticClass: "buttons" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "transactions deposit",
                                          class: [
                                            {
                                              geolocation_check_in_progress:
                                                _vm.tempPromotionTypeFromSessionStorage &&
                                                _vm
                                                  .tempPromotionTypeFromSessionStorage
                                                  .name === "deposit" &&
                                                _vm.geolocationProgress !==
                                                  "completed"
                                            }
                                          ],
                                          attrs: {
                                            id: "my_profile_deposit_btn",
                                            color: "success",
                                            "x-large": ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.depositAction()
                                            }
                                          }
                                        },
                                        [
                                          !_vm.tempPromotionTypeFromSessionStorage ||
                                          (_vm.tempPromotionTypeFromSessionStorage &&
                                            _vm
                                              .tempPromotionTypeFromSessionStorage
                                              .name !== "deposit") ||
                                          !_vm.geolocationProgress ||
                                            _vm.geolocationProgress ===
                                              "completed"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("MyAccount.Deposit")
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.tempPromotionTypeFromSessionStorage &&
                                          _vm
                                            .tempPromotionTypeFromSessionStorage
                                            .name === "deposit" &&
                                          _vm.geolocationProgress &&
                                            _vm.geolocationProgress !==
                                              "completed"
                                            ? _c("dots-loader")
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "transactions withdraw",
                                          attrs: {
                                            id: "my_profile_withdraw_btn",
                                            "x-large": ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.go2WalletPage(
                                                "withdrawal"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("MyAccount.Withdraw")
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.cashDepositAtKiosk ||
                                  _vm.withdrawAtSportsbookButton
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "buttons second_row",
                                          class: {
                                            two_buttons:
                                              _vm.cashDepositAtKiosk &&
                                              _vm.withdrawAtSportsbookButton
                                          }
                                        },
                                        [
                                          _vm.cashDepositAtKiosk
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id:
                                                      "my_profile_deposit_at_kiosk_btn",
                                                    "x-large": ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.go2DepositAtKioskPage()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MyAccount.DepositAtKiosk"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.withdrawAtSportsbookButton
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id:
                                                      "my_profile_withdraw_btn",
                                                    "x-large": ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.go2CashInShopPage()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Payments.CashInShop"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "account_links",
                            class: [
                              _vm.state,
                              { acc_summary_on: _vm.accountSummaryFlow }
                            ]
                          },
                          [
                            _c("site-navigation", {
                              staticClass: "account_links",
                              attrs: { "navigation-section": _vm.AccountFlow }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mobileBigAndBelow
                ? _c(
                    "v-dialog",
                    {
                      attrs: {
                        "content-class": "dialog-myaccount",
                        persistent: "",
                        fullscreen: _vm.brandTemplate !== "generic_2",
                        "hide-overlay": _vm.brandTemplate !== "generic_2",
                        transition: "dialog-bottom-transition"
                      },
                      model: {
                        value: _vm.dialogMyAccount,
                        callback: function($$v) {
                          _vm.dialogMyAccount = $$v
                        },
                        expression: "dialogMyAccount"
                      }
                    },
                    [
                      _c("div", { staticClass: "account_mobile" }, [
                        _vm.brandTemplate !== "generic_2"
                          ? _c(
                              "div",
                              { staticClass: "account_details" },
                              [
                                _c("account-info-component"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "buttons" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "transactions deposit",
                                        class: [
                                          {
                                            geolocation_check_in_progress:
                                              _vm.tempPromotionTypeFromSessionStorage &&
                                              _vm
                                                .tempPromotionTypeFromSessionStorage
                                                .name === "deposit" &&
                                              _vm.geolocationProgress !==
                                                "completed"
                                          }
                                        ],
                                        attrs: {
                                          id: "my_profile_deposit_btn",
                                          color: "success",
                                          "x-large": ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.depositAction()
                                          }
                                        }
                                      },
                                      [
                                        !_vm.tempPromotionTypeFromSessionStorage ||
                                        (_vm.tempPromotionTypeFromSessionStorage &&
                                          _vm
                                            .tempPromotionTypeFromSessionStorage
                                            .name !== "deposit") ||
                                        !_vm.geolocationProgress ||
                                          _vm.geolocationProgress ===
                                            "completed"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("MyAccount.Deposit")
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.tempPromotionTypeFromSessionStorage &&
                                        _vm.tempPromotionTypeFromSessionStorage
                                          .name === "deposit" &&
                                        _vm.geolocationProgress &&
                                          _vm.geolocationProgress !==
                                            "completed"
                                          ? _c("dots-loader")
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "transactions withdraw",
                                        attrs: {
                                          id: "my_profile_withdraw_btn",
                                          "x-large": ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.go2WalletPage(
                                              "withdrawal"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("MyAccount.Withdraw"))
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.cashDepositAtKiosk ||
                                _vm.withdrawAtSportsbookButton
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "buttons second_row",
                                        class: {
                                          two_buttons:
                                            _vm.cashDepositAtKiosk &&
                                            _vm.withdrawAtSportsbookButton
                                        }
                                      },
                                      [
                                        _vm.cashDepositAtKiosk
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "transactions deposit",
                                                attrs: {
                                                  id:
                                                    "my_profile_deposit_at_kiosk_btn",
                                                  "x-large": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.go2DepositAtKioskPage()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MyAccount.DepositAtKiosk"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.withdrawAtSportsbookButton
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "transactions withdraw ri-wd-cashinshop",
                                                attrs: {
                                                  id: "my_profile_withdraw_btn",
                                                  "x-large": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.go2CashInShopPage()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Payments.CashInShop"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brandTemplate === "generic_2"
                          ? _c("div", { staticClass: "account_details" }, [
                              _c("div", { staticClass: "user_details" }, [
                                _c(
                                  "div",
                                  { staticClass: "user_details_name" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "user_notifications" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "user_image",
                                            class: {
                                              withAlerts: _vm.noOfMsgs > 0
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.openMsgCenterDialog()
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("account_circle")
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        (_vm.xtremepushWebInitialized ||
                                          _vm.xtremePushEnabledMobile) &&
                                        _vm.xtremepushInboxEnabled
                                          ? _c("xtremepush-inbox")
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "user_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customerContext.Name &&
                                            _vm.customerContext.Name[0]
                                        ) +
                                          " " +
                                          _vm._s(_vm.customerContext.Name[1]) +
                                          "\n              "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "sessionDetails" }, [
                                  _c("p", { staticClass: "accountnumber" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("MyAccount.AccountNumber")
                                        )
                                      )
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(_vm.accountNumber || "--")
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.state !== "NJ"
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "sessionDuration sessiondur"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("MyAccount.SessionTime")
                                              )
                                            )
                                          ]),
                                          _vm._v(" " + _vm._s(_vm.sessionTime))
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.state === "NJ"
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "sessionDuration sessiondur"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "MyAccount.SessionTime." +
                                                    _vm.state
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" " + _vm._s(_vm.sessionTime))
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "lastlogin lastlogdur" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("MyAccount.LastLogin"))
                                        )
                                      ]),
                                      _vm._v(" " + _vm._s(_vm.lastLogin))
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.state === "NJ"
                                    ? _c("p", { staticClass: "current-time" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("MyAccount.CurrentTime")
                                            )
                                          )
                                        ]),
                                        _vm._v(" " + _vm._s(_vm.currentTime))
                                      ])
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "balance_actions" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "account_balance",
                                    class: {
                                      withPromoBalance: _vm.promoBalanceSum
                                    }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "balance",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.refreshAccountsDetails()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "balance_holder" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "text" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MyAccount.TotalCash"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                !_vm.balanceLoader
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "value",
                                                        attrs: {
                                                          id:
                                                            "sportbook-balance"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              _vm.balanceSum ||
                                                                0
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.balanceLoader
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "loading"
                                                      },
                                                      [_c("dots-loader")],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.promoBalanceSum
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "balance_holder"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MyAccount.PromoBalance"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.balanceLoader
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass: "value"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency"
                                                                )(
                                                                  _vm.promoBalanceSum ||
                                                                    0
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.balanceLoader
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "loading"
                                                          },
                                                          [_c("dots-loader")],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "buttons_holder" }, [
                                  _c(
                                    "div",
                                    { staticClass: "buttons" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "transactions deposit",
                                          class: [
                                            {
                                              geolocation_check_in_progress:
                                                _vm.tempPromotionTypeFromSessionStorage &&
                                                _vm
                                                  .tempPromotionTypeFromSessionStorage
                                                  .name === "deposit" &&
                                                _vm.geolocationProgress !==
                                                  "completed"
                                            }
                                          ],
                                          attrs: {
                                            id: "my_profile_deposit_btn",
                                            color: "success",
                                            "x-large": ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.depositAction()
                                            }
                                          }
                                        },
                                        [
                                          !_vm.tempPromotionTypeFromSessionStorage ||
                                          (_vm.tempPromotionTypeFromSessionStorage &&
                                            _vm
                                              .tempPromotionTypeFromSessionStorage
                                              .name !== "deposit") ||
                                          !_vm.geolocationProgress ||
                                            _vm.geolocationProgress ===
                                              "completed"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("MyAccount.Deposit")
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.tempPromotionTypeFromSessionStorage &&
                                          _vm
                                            .tempPromotionTypeFromSessionStorage
                                            .name === "deposit" &&
                                          _vm.geolocationProgress &&
                                            _vm.geolocationProgress !==
                                              "completed"
                                            ? _c("dots-loader")
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "transactions withdraw",
                                          attrs: {
                                            id: "my_profile_withdraw_btn",
                                            "x-large": ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.go2WalletPage(
                                                "withdrawal"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("MyAccount.Withdraw")
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.cashDepositAtKiosk ||
                                  _vm.withdrawAtSportsbookButton
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "buttons second_row",
                                          class: {
                                            two_buttons:
                                              _vm.cashDepositAtKiosk &&
                                              _vm.withdrawAtSportsbookButton
                                          }
                                        },
                                        [
                                          _vm.cashDepositAtKiosk
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id:
                                                      "my_profile_deposit_at_kiosk_btn",
                                                    "x-large": ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.go2DepositAtKioskPage()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MyAccount.DepositAtKiosk"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.withdrawAtSportsbookButton
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id:
                                                      "my_profile_withdraw_btn",
                                                    "x-large": ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.go2CashInShopPage()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Payments.CashInShop"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "account_links",
                            class: [
                              _vm.state,
                              { acc_summary_on: _vm.accountSummaryFlow }
                            ]
                          },
                          [
                            _c("site-navigation", {
                              staticClass: "account_links",
                              attrs: { "navigation-section": _vm.AccountFlow }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11fa3720", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11fa3720","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountInfoWidgetComponent.vue
// module id = null
// module chunks = 